import { MessageSeverity } from '@app/components/Messages/types';
import {
  CART_TRAY_MSG_TYPE,
  CartTrayMessageData,
  CartTrayMessageType,
} from '../Messages';

const WHITELISTED_TYPES: CartTrayMessageType[] = [
  CART_TRAY_MSG_TYPE.NonsaleableProductRemoval,
  CART_TRAY_MSG_TYPE.ExpiredProductRemoval,
  CART_TRAY_MSG_TYPE.DiscountShipping,
];

export const filterAndSortMessages = ({
  messages,
  productTypeIds,
}: {
  messages: CartTrayMessageData[];
  productTypeIds: Set<string | null>;
}) => {
  const whiteListedTypes = WHITELISTED_TYPES;

  const candidateMessages = messages.filter((message) => {
    if (message.severity === MessageSeverity.Success) return false;

    const isWhiteListed = whiteListedTypes.includes(message.type);
    const matchesProductType = message.discount_product_type_ids?.some(
      (discounted_id) => productTypeIds.has(discounted_id)
    );

    return isWhiteListed || matchesProductType;
  });

  return candidateMessages.sort((a, b) =>
    compareMessages(a, b, whiteListedTypes)
  );
};

const compareMessages = (
  a: CartTrayMessageData,
  b: CartTrayMessageData,
  whiteListedTypes: CartTrayMessageType[]
) => {
  // Whitelisted types should always display first
  const aIsWhitelisted = whiteListedTypes.includes(a.type);
  const bIsWhitelisted = whiteListedTypes.includes(b.type);

  if (aIsWhitelisted && !bIsWhitelisted) return -1;
  if (!aIsWhitelisted && bIsWhitelisted) return 1;

  // Within whitelisted messages, sort by WHITELISTED_TYPES array index order
  if (aIsWhitelisted && bIsWhitelisted) {
    const aIndex = whiteListedTypes.indexOf(a.type);
    const bIndex = whiteListedTypes.indexOf(b.type);

    return aIndex - bIndex;
  }

  // Then sort by priority: lower numbers first, no priority last.
  const aHasNumberedPriority = typeof a.priority === 'number';
  const bHasNumberedPriority = typeof b.priority === 'number';

  if (aHasNumberedPriority && !bHasNumberedPriority) return -1;
  if (!aHasNumberedPriority && bHasNumberedPriority) return 1;
  if (aHasNumberedPriority && bHasNumberedPriority) {
    // @ts-expect-error ts is complaining that `.priority` can be null, but the guards have checked that priority is a number
    return a.priority - b.priority;
  }

  return 0;
};
